import React, { useEffect, useState } from 'react';
import Modal from '../../../../../../component/modal/Modal';
import InputField from '../../../../../../component/form/FormInput';
import Button from '../../../../../../component/ui/Button';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import {
	copyToClipboard,
	generateStrongPassword,
	newObjectCreater,
} from '../../../../../../utils/controller';
import { toast } from 'react-toastify';
import {
	createSettingsUser,
	getSettingsRoles,
	getUserById,
	UpdateSettingsUser,
} from '../../../../../../services/settings/users';
import { useSelector } from 'react-redux';

export default function CreateUserModal({
	isOpenModal,
	setIsOpenModal,
	isEdit,
	userId,
	getUsersList,
}) {
	const [loader, setLoader] = useState(false);
	const [domain, setDomain] = useState('');
	const [isVisible, setIsVisible] = useState(false);
	const [error, setError] = useState({});
	const [rolesList, setRolesList] = useState([]);
	const userDetails = useSelector((state) => state?.userInfo?.userInfo.data);
	const [createUser, setCreateUser] = useState({
		first_name: '',
		last_name: '',
		role_id: '',
		email: '',
		phone_number: '',
		// sub_domain: '',
		username: '',
		password: '',
		send_password_reset_link: false,
	});
	const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
	const handleGeneratePassword = (isPasswordUpdated) => {
		if (setIsPasswordUpdated) {
			setIsPasswordUpdated(true);
		}
		let generated_password = generateStrongPassword();
		handleFormData('password', generated_password);
		var errors = { ...error };
		delete errors.password;
		setError(errors);
		setIsVisible(!isVisible);
	};

	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	const handleFormData = (key, value, required) => {
		setCreateUser((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (key === 'first_name') {
				if (value) {
					delete newError[key];
				} else {
					newError[key] = 'Please enter first name in the field';
				}
			}
			if (key === 'last_name') {
				if (value) {
					delete newError[key];
				} else {
					newError[key] = 'Please enter last name in the field';
				}
			}
			if (key === 'role_id') {
				if (value === '' || value == null || value === undefined) {
					newError[key] = 'Please select role from the list';
				} else {
					delete newError[key];
				}
			}

			if (key === 'phone_number') {
				if (value) {
					if (value.length > 10 || value.length < 10) {
						newError.phone_number = `Please enter valid phone number`;
					} else {
						delete newError[key];
					}
				} else {
					// newError[key] = 'Please enter valid phone number';
					delete newError[key];
				}
			}
			if (key === 'email') {
				if (value) {
					if (validateEmail(value)) {
						delete newError[key];
					} else {
						newError[key] = 'Please enter valid email address';
					}
				} else {
					newError[key] = 'Please enter valid email address';
				}
			}
			if (key === 'username') {
				if (value) {
					delete newError[key];
				} else {
					newError[key] = 'Please enter username in the field';
				}
			}
			if (key === 'password') {
				if (value) {
					delete newError[key];
				} else {
					newError[key] = 'Please enter password in the field';
				}
			}

			setError(newError);
		}
	};

	function checkValidation() {
		const newError = { ...error };
		if (
			!createUser.first_name ||
			createUser.first_name === '' ||
			createUser.first_name === undefined
		) {
			newError.first_name = 'Please enter first name in the field.';
		} else {
			delete newError.first_name;
		}
		if (
			!createUser.last_name ||
			createUser.last_name === '' ||
			createUser.last_name === undefined
		) {
			newError.last_name = 'Please enter last name in the field.';
		} else {
			delete newError.last_name;
		}
		if (!createUser.role_id || createUser.role_id === '' || createUser.role_id === undefined) {
			newError.role_id = 'Please select role from the list';
		} else {
			delete newError.role_id;
		}
		if (!createUser.email || createUser.email === '' || createUser.email === undefined) {
			newError.email = 'Please enter email in the field.';
		} else {
			delete newError.email;
		}
		if (!createUser.password || createUser.password === '' || createUser.password === undefined) {
			newError.password = 'Please enter password in the field.';
		} else {
			delete newError.password;
		}
		if (!createUser.username || createUser.username === '' || createUser.username === undefined) {
			newError.username = 'Please enter username in the field.';
		} else {
			delete newError.username;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleUser = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Creating user failed! Please fill required fields.');
		} else {
			try {
				setLoader(true);
				var data = {
					first_name: createUser.first_name,
					last_name: createUser.last_name,
					role_id: createUser.role_id,
					email: createUser.email,
					phone_number: createUser.phone_number,
					username: createUser.username,
					send_password_reset_link: false,
					website_url: window.location.origin + '/user/' + userDetails.sub_domain,
					...(isPasswordUpdated || !isEdit ? { password: createUser.password } : {}),
				};
				if (isEdit) {
					const updateRes = await UpdateSettingsUser(data, userId);
					if (updateRes.success) {
						toast.success(updateRes.message);
						getUsersList();
						setIsOpenModal(false);
					} else {
						toast.error(updateRes.message);
					}
				} else {
					const res = await createSettingsUser(data);
					if (res.success) {
						toast.success(res.message);
						getUsersList();
						setIsOpenModal(false);
					} else {
						toast.error(res.message);
					}
				}
			} catch (error) {
				toast.error(error.message || 'something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	const getUserDetails = async () => {
		try {
			const user = await getUserById(userId);
			if (user !== undefined && user !== null) {
				const data = {
					first_name: user.first_name || '',
					last_name: user.last_name,
					role_id: user.role !== null && user.role !== undefined ? user.role.id : '',
					email: user.email || '',
					phone_number: user.phone_number || '',
					// sub_domain: user.sub_domain,
					// website_url: user.website_url || '',
					username: user.username || '',
					password:
						user.password !== undefined && user.password !== null ? user.password.slice(0, 8) : '',
					send_password_reset_link: user.send_password_reset_link || false,
				};
				setCreateUser(data);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const getRoles = async () => {
		try {
			const { roles } = await getSettingsRoles({ pageSize: 10000, page: 1 });
			const list = newObjectCreater(roles);
			setRolesList(list);
		} catch (error) {
			toast.error(error.message || 'Something wenr wrong!');
		}
	};

	useEffect(() => {
		getRoles();
	}, []);

	useEffect(() => {
		if (userId && isEdit) {
			getUserDetails();
		}
	}, [isEdit]);

	useEffect(() => {
		const domainName = new URL(window.location.href).hostname;
		setDomain(domainName);
	}, []);

	return (
		<Modal
			className="create-user-model"
			title={isEdit ? 'Edit User' : 'Add User'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div className="row my-3">
				<div className="col-4">
					<InputField
						label="First Name"
						name="first_name"
						placeholder="First name"
						autoFocus={true}
						type="text"
						required={true}
						value={createUser.first_name}
						onChange={(value) => handleFormData('first_name', value, true)}
						error={error?.first_name}
					/>
				</div>
				<div className="col-4">
					<InputField
						label="Last Name"
						name="last_name"
						placeholder="Last Name"
						type="text"
						required={true}
						value={createUser.last_name}
						onChange={(value) => {
							// var value = valueData?.replace(/[^0-9.]/g, '');
							handleFormData('last_name', value, true);
						}}
						error={error?.last_name}
					/>
				</div>
				<div className="col-4">
					<InputSelect
						label="Role"
						placeholder="Select Role"
						name="role_name"
						required={true}
						options={rolesList}
						returnInputValue={false}
						value={createUser?.role_id}
						onSelect={(option) => {
							handleFormData('role_id', option.key, true);
						}}
						onChange={(value) => {}}
						error={error?.role_id}
					/>
				</div>
			</div>
			<div className="row my-3">
				<div className="col-4">
					<InputField
						label="Email"
						placeholder="Email"
						name="email"
						type="text"
						required={true}
						value={createUser.email}
						onChange={(value) => handleFormData('email', value, true)}
						error={error?.email}
					/>
				</div>
				<div className="col-4">
					<InputField
						label="Phone Number"
						placeholder="Phone Number"
						name="phone_number"
						type="text"
						required={false}
						value={createUser.phone_number}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleFormData('phone_number', value, true);
						}}
						error={error?.phone_number}
					/>
				</div>
				<div className="col-4">
					<div
						className="fw-bold text-dark mb-2"
						style={{ fontSize: '1.4rem' }}
					>
						Website Url
					</div>
					<div className="input-group">
						<div className="input-group-append">
							<span
								className="input-group-text font-medium"
								style={{
									minHeight: '3.6rem',
									fontSize: '1.4rem',
									marginLeft: '.1rem',
									minWidth: '5rem',
									justifyContent: 'center',
									color: 'var(--brand-color)',
									borderRadius: ' 8px 0 0 8px',
								}}
							>
								{`${domain}/user/`}
							</span>
						</div>
						<input
							style={{
								borderRadius: '8px',
								borderTopLeftRadius: '0px',
								borderBottomLeftRadius: '0px',
								border: '1px solid rgba(85, 91, 103, 0.15)',
								backgroundColor: '#FCFCFC',
								padding: '8px',
								borderLeft: '0',
							}}
							type="text"
							className={`form-control ${userDetails?.settings?.general_preferences?.enable_auto_capitalize_input?.value ? 'uppercase' : 'capitalize'}`}
							id="inlineFormInputGroup"
							placeholder="Enter"
							onChange={(e) => handleFormData('sub_domain', userDetails.sub_domain)}
							value={userDetails.sub_domain}
							label=""
							disabled={true}
							name={'sub_domain'}
							error={error?.sub_domain}
						/>
					</div>
					{/* <InputField
						label="Website Url"
						placeholder="Website Url"
						type="text"
						required={false}
						value={createUser.website_url}
						onChange={(value) => {
							// var value = valueData?.replace(/[^0-9.]/g, '');
							handleFormData('website_url', value, true);
						}}
						error={error?.rate_in_percentage}
					/> */}
				</div>
			</div>
			<div className="fs-3 fw-semibold text-dark py-4">Login Details</div>
			<div className="row my-3">
				<div className="col-4">
					<InputField
						label="Username"
						placeholder="Username"
						name="username"
						type="text"
						required={false}
						value={createUser.username}
						onChange={(value) => handleFormData('username', value, true)}
						error={error?.username}
					/>
				</div>
				<div className="col-4 position-relative">
					<InputField
						type="password"
						value={createUser.password}
						disabled={userId && isEdit}
						name="password"
						placeholder="password"
						label="Password"
						onChange={(value) => {
							handleFormData('password', value, true);
						}}
						error={error?.password}
						required={false}
						autoComplete="new-password"
						showPasswordIcon={userId && isEdit && !isPasswordUpdated ? false : true}
					/>
					{isVisible ? (
						<span
							className="password-auto-generate curser-pointer fw-semibold text-decoration-none z-100"
							style={{ color: '#3b58ff' }}
							onClick={() => copyToClipboard(createUser.password)}
						>
							Copy
						</span>
					) : (
						<span
							className="password-auto-generate curser-pointer fw-semibold text-decoration-none"
							style={{ color: '#3b58ff' }}
							onClick={() => handleGeneratePassword(userId && isEdit ? true : false)}
						>
							{userId && isEdit ? 'Update Password' : 'Auto-Generate'}
						</span>
					)}
				</div>
				<div
					className=" col-4 d-flex p-3"
					style={{ marginTop: '22px' }}
				>
					<input
						class="form-check-input"
						type="checkbox"
						checked={createUser.send_password_reset_link}
						id="flexCheckDefault"
						onChange={(e) =>
							handleFormData('send_password_reset_link', !createUser.send_password_reset_link)
						}
					/>
					<div className="fs-5 fw-semibold text-dark">Send Login Details on Email</div>
				</div>
			</div>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
					marginTop: '10px',
					gap: '10px',
				}}
			>
				<Button
					type="button"
					button={isEdit ? `Update` : `Add`}
					className="mt-0 px-4 btn-primary relative"
					loader={loader}
					onClick={() => handleUser()}
				/>
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
			</div>
		</Modal>
	);
}
